export const parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split(", ");
    const [day, month, year] = datePart.split("/").map(Number);
    return new Date(year, month - 1, day, ...timePart.split(":").map(Number));
  };
  
  